<template>
  <v-menu offset-y nudge-bottom="22" min-width="175" left :elevation="$vuetify.theme.dark ? 9 : 8">
    <!-- Activator -->
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" class="d-flex align-center me-4" v-on="on">
        <v-img :src="activeLocale.img" :alt="$i18n.locale" height="14px" width="22px" class="me-2"></v-img>
        <span v-if="$vuetify.breakpoint.smAndUp">{{ activeLocale.title }}</span>
      </div>
    </template>

    <!-- Options List -->
    <v-list>
      <v-list-item-group :value="$i18n.locale" @change="updateActiveLocale">
        <v-list-item v-for="locale in locales" :key="locale.locale" :value="locale.locale">
          <v-img :src="locale.img" height="14px" width="22px" :alt="locale.locale" class="me-2"></v-img>
          <v-list-item-title>{{ locale.title }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import { i18n, loadLanguageAsync } from "@/plugins/i18n";
import useAppConfig from "@core/@app-config/useAppConfig";
import { computed } from "@vue/composition-api";
import { supportedLocales } from "@/@core/utils/i18n_utils";

export default {
  setup(props, context) {
    const { isRtl } = useAppConfig();

    const locales = supportedLocales;

    const activeLocale = computed(() => {
      let locale = locales.find((a) => a.locale == i18n.locale);
      return locale ?? locales[0];
    });

    const updateActiveLocale = async (locale) => {
      // Set to RTL mode if locale is arabic
      isRtl.value = locale === "ar";

      await loadLanguageAsync(locale);

      setTimeout(() => {
        window.location.href = window.location.href;
      }, 200);
    };

    return {
      locales,
      updateActiveLocale,
      activeLocale,
    };
  },
};
</script>
